<template>
  <div>
    <div class="filters inline">
      <h4>{{ $t('label.filter') }}</h4>
      <div
        class="filter"
        v-for="(division, index) in divisions"
        :key="index"
      >
        <label :for="'division-'+index">
          <input
            type="radio"
            :id="'division-'+index"
            v-model="selectedDivision"
            :value="division"
          > {{ division }}
        </label>
      </div>
    </div>

    <div id="containerChart"></div>

    <div class="col-md-6 offset-md-3 filters">
      <h4>{{ $t('label.options') }}</h4>
      <div
        class="filter"
        v-for="(field, index) in chartData.fields"
        :key="index"
      >
        <label :for="'field-'+index">
          <input
            type="radio"
            :id="'field-'+index"
            v-model="selectedField"
            :value="field"
          > {{ field }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'

export default {
  name: 'GraphView',
  data: function () {
    return {
      hchart: undefined,
      divisions: [],
      selectedField: '',
      selectedDivision: ''
    }
  },
  props: {
    chartData: undefined,
    chartOptions: undefined
  },
  mounted: function () {
    this.selectedField = this.chartData.fields[0]
  },
  watch: {
    selectedDivision: function () {
      this.updateSeries(this.chartData.values, this.selectedField, this.selectedDivision)
    },
    selectedField: function () {
      this.divisions = this.getKeys(this.chartData.values[this.selectedField])
      console.log('Divisions: ' + this.divisions)
      this.selectedDivision = this.divisions[0] // NOTE: watch.selectedDivision is not called
      this.updateSeries(this.chartData.values, this.selectedField, this.selectedDivision)
    },
    chartData: function () {
      if (this.hchart !== undefined) {
        this.selectedField = this.chartData.fields[0]
        this.hchart.update(this.chartOptions)
      }
    }
  },
  methods: {
    getKeys: function (data) {
      var retVal = []
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          retVal.push(key)
        }
      }
      console.log('Get keys: ' + JSON.stringify(retVal))
      return retVal
    },
    getSeries: function (data, categories) {
      var retVal = []
      for (var i = 0; i < categories.length; i++) {
        var dataArr = []
        for (var val in data) {
          if (data.hasOwnProperty(val)) {
            dataArr.push(data[val][categories[i]])
          }
        }
        let tempSeries = {
          name: categories[i],
          data: dataArr
        }
        if (this.chartOptions.additionalOptions != null) {
          if (this.chartOptions.additionalOptions.seriesColors != null) {
            tempSeries.color = this.chartOptions.additionalOptions.seriesColors[categories[i]]
          }
        }
        retVal.push(tempSeries)
      }
      return retVal
    },
    updateSeries: function (data, selectedField, selectedDivision) {
      if (selectedDivision === undefined) {
        selectedDivision = 0
      }
      console.log('categories \n')
      let categories = this.getKeys(data[selectedField][selectedDivision])
      console.log('subcategories now \n')
      let subcategories = this.getKeys(data[selectedField][selectedDivision][categories[0]])
      let series = this.getSeries(data[selectedField][selectedDivision], subcategories)
      console.log(JSON.stringify(series))
      var length

      if (this.hchart === undefined) {
        this.hchart = new Highcharts.Chart('containerChart', this.chartOptions)
      } else {
        length = this.hchart.series.length
        for (var i = length - 1; i >= 0; i--) {
          this.hchart.series[i].remove(false)
        }
      }
      this.hchart.setTitle({ text: selectedField }, { text: selectedDivision })
      this.hchart.xAxis[0].setCategories(categories, false)
      length = series.length
      for (i = 0; i < length; i++) {
        this.hchart.addSeries(series[i], false)
      }
      this.hchart.redraw()
    }
  }
}
</script>

<style lang='scss' scoped>
@import "~styles/_vars.scss";

#containerChart {
  margin: 3rem 0;
}

.filters {
  padding: 0;
  display: inline-block;
  border-radius: $border-radius-standard;
  box-shadow: $drop-shadow-card;
  overflow: hidden;

  &.inline {
    display: block;
    text-align: center;

    .filter {
      display: inline-block;
    }
  }

  h4 {
    background: $primary-color;
    font-size: 0.75rem;
    text-transform: uppercase;
    color: $white;
    font-weight: $semibold;
    letter-spacing: 3px;
    padding: 0.75rem;
    border-bottom: 1px solid $border-color;
  }

  .filter {
    font-size: 0.85rem;
    padding: 0.25rem 0.75rem;

    * {
      display: inline-block;
      cursor: pointer;
    }

    input {
      margin-right: 0.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// GraphView.vue?40862b07